import Image from "next/image";

import cn from "classnames";
import { Image as ImageType } from "sanity";

import { RichText } from "@/components/richText/richText.component";
import { Text } from "@/components/text/text.component";

import { RichText as RichTextType } from "@/sanity.types";
import { urlFor } from "@/sanity/utils";

const renderTitleWithSuperscript = (text: string) => {
  if (!text) return text;

  // Only match symbols like †, ‡, *, § (removed 0-9 so regular numbers stay normal)
  const regex = /([†‡*§]+)/g;

  if (!regex.test(text)) return text;

  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) => {
        // Check if this specific part is one of our marker symbols
        if (/^[†‡*§]+$/.test(part)) {
          return (
            <sup key={index} className="-top-3 text-xs lg:-top-2.5 lg:text-sm">
              {part}
            </sup>
          );
        }
        return part;
      })}
    </>
  );
};

export const ReasonsToBuyItem4Column = ({
  icon,
  title,
  description,
  className,
  layout = "stacked",
}: ReasonsToBuyItem4ColumnProps) => {
  const imageUrl = icon ? urlFor(icon).url() : null;
  const inline = layout === "inline";

  return (
    <div
      className={cn(
        "mx-5 rounded-[20px] md:mx-0",
        inline
          ? "flex flex-row items-start gap-3 text-left"
          : "border-secondary-100 flex flex-[1_0_0] flex-col items-start justify-center gap-2 self-stretch border bg-white p-4 text-center lg:p-8",
        className,
      )}>
      {imageUrl && (
        <div className="text-primary mx-auto flex size-12 shrink-0 items-center justify-center">
          <Image
            src={imageUrl}
            alt=""
            width={56}
            height={56}
            className="mx-auto size-full object-contain"
            unoptimized
          />
        </div>
      )}
      <div className="flex min-w-0 flex-col gap-2">
        <Text
          variant={inline ? "subtitle2" : "h6"}
          component="h3"
          className="text-secondary-100">
          {renderTitleWithSuperscript(title)}
        </Text>
        <RichText>{description}</RichText>
      </div>
    </div>
  );
};

export type ReasonsToBuyItem4ColumnProps = {
  icon?: ImageType;
  title: string;
  description?: RichTextType;
  className?: string;
  layout?: "stacked" | "inline";
};
